import type { FavoriteItemDTO } from "@packages/domain";
import { FavoriteCard } from "@/components/favorite-card";
import styles from "./favorites-list.module.css";

type FavoritesListProps = {
  favorites: FavoriteItemDTO[];
  onRemove: (advertiseId: number) => void;
  removingId: number | null;
};

export function FavoritesList({
  favorites,
  onRemove,
  removingId,
}: Readonly<FavoritesListProps>) {
  return (
    <div className={styles.grid} data-testid="favorites-list">
      {favorites.map((favorite) => (
        <FavoriteCard
          key={favorite.guid}
          favorite={favorite}
          onRemove={() => onRemove(favorite.advertiseId)}
          isRemoving={removingId === favorite.advertiseId}
        />
      ))}
    </div>
  );
}
